import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { migrateFontBoldStyleToFontWeightMutably } from '../../../services/compat/migration.helpers';
import { type ElementMigration } from '../../../services/compat/migrations/layout-migration.models';

export const barcodeScannerV2Migration: ElementMigration = {
  mode: 'props',
  description: 'Migrate inputFont bold style to use fontWeight property',
  run: (props: PartialPropsOf<'barcodeScanner'>): void => {
    migrateFontBoldStyleToFontWeightMutably(props.style?.inputFont);
  },
};
